var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "arrow_right_alt"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3658_2751",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 32,
    height: 32,
    fill: "#FF4700"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3658_2751)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow_right_alt_2",
    d: "M22.4884 17.0701L22.6591 16.8993H22.4177H6.73044C6.2334 16.8993 5.83047 16.4964 5.83047 15.9994C5.83047 15.5023 6.2334 15.0994 6.73044 15.0994L22.4177 15.0994H22.6591L22.4884 14.9287L18.0987 10.539C17.7477 10.188 17.7436 9.62013 18.0895 9.2641C18.4425 8.90074 19.0246 8.89655 19.3829 9.25479L25.39 15.262C25.7973 15.6692 25.7973 16.3295 25.39 16.7368L19.3829 22.744C19.0246 23.1022 18.4425 23.098 18.0895 22.7346C17.7436 22.3786 17.7477 21.8108 18.0987 21.4598L22.4884 17.0701Z",
    fill: "#FF4700",
    stroke: "#FFF0EB",
    strokeWidth: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.2a9f767b358c47bf52dcba7173c5dc51.svg";
export { ForwardRef as ReactComponent };